import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import React, { useCallback, useContext, useState } from 'react'
import { MessageContext } from './Contexts'
import ActionButtons from './ActionButtons'
import { setModes } from 'modules/Utils'
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
  dialogContent: {
    width: 475,
  }
})

export function AddCommentDialog({ mode, setMode, callback, commentFn, params, heading }) {
  const { messageDispatch } = useContext(MessageContext)

  const [comment, setComment] = useState('')

  const classes = useStyles()

  const addComment = useCallback(async (e, setMode) => {
    try {
      setMode('pending')
      const { data: { success, info, comment: commentResp } } = await commentFn({comment: comment, ...params})
      if (success) {
        info && messageDispatch({ type: 'info', payload: info })
        await setModes(setMode, ['completing', 1500, ''])
      } else {
        throw new Error(info ? info : 'An error occurred')
      }
      callback && callback(commentResp)
    } catch (error) {
      setMode('')
      messageDispatch({ type: 'warning', payload: error.message })
    }
  }, [params, comment, callback, commentFn, messageDispatch])

  const clearDialog = useCallback(() => {
    setComment('')
  }, [setComment])

  return (
    <Dialog
      open={mode !== ''}
      aria-labelledby='add-dialog'
      slotProps={{
        transition:
        { onEnter: clearDialog }
      }}
      disableRestoreFocus
    >
      <DialogTitle>Add billing comment</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Grid container>
          <Grid item xs={12}>
            <TextField
              sx={{
                marginTop: 1,
              }}
              label='Comment'
              multiline
              rows={6}
              fullWidth
              variant='outlined'
              autoFocus
              value={comment}
              onChange={({ target: { value } }) => {
                setComment(value)
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <ActionButtons
          mode={mode}
          setMode={setMode}
          action={addComment}
          cancel={(e, setMode) => setMode('')}
          actionTitle='Add comment'
          neverShowEdit={true}
        />
      </DialogActions>
    </Dialog>
  );
}
